import React from "react";
import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { Home } from "lucide-react";

export default function NotFound() {
  return (
    <div className="min-h-[60vh] flex flex-col items-center justify-center text-center px-4 py-24">
      <p className="font-display text-7xl text-amber-500">404</p>
      <h1 className="font-display text-2xl text-[#0a2540] mt-4">पृष्ठ नहीं मिला</h1>
      <p className="text-slate-500 mt-2 max-w-md">
        क्षमा करें, आप जिस पृष्ठ की तलाश कर रहे हैं वह उपलब्ध नहीं है।
      </p>
      <Link to="/" className="mt-6">
        <Button className="bg-[#0a2540] hover:bg-[#061729] gap-2"><Home size={17} /> मुख्य पृष्ठ पर जाएं</Button>
      </Link>
    </div>
  );
}
